import React from 'react';
import { motion } from 'framer-motion';
import { FaCalendarAlt } from 'react-icons/fa';

const AdminPageHeader = ({ 
  title, 
  subtitle, 
  icon, 
  children 
}) => {
  const currentDate = new Date().toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 left-64 right-0 z-40 bg-white border-b border-gray-200 px-6 py-5 shadow-sm"
      style={{ minHeight: '120px' }}
    >
      <div className="flex items-center justify-between h-full">
        <div className="flex items-center space-x-4 flex-1 min-w-0">
          {icon && (
            <div className="flex-shrink-0 p-3 rounded-xl bg-gradient-to-br from-orange-50 to-pink-50 text-orange-500 border border-orange-200">
              {icon}
            </div>
          )}
          <div className="flex-1 min-w-0">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-1 truncate">
              {title}
            </h1>
            {subtitle && (
              <p className="text-gray-600 text-sm sm:text-base line-clamp-1">{subtitle}</p>
            )}
          </div>
        </div>
        
        <div className="flex items-center space-x-4 flex-shrink-0 ml-4">
          <div className="hidden md:flex items-center space-x-2 text-gray-500">
            <FaCalendarAlt className="w-4 h-4" />
            <span className="text-sm font-medium whitespace-nowrap">{currentDate}</span>
          </div>
          {children && (
            <div className="flex items-center space-x-3">
              {children}
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default AdminPageHeader;
